import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const isProd = process.env.NODE_ENV === "production";

export const supabase =
    url && anonKey
        ? createClient(url, anonKey, {
              auth: {
                  persistSession: false,
                  autoRefreshToken: false,
                  detectSessionInUrl: false,
                  debug: false,
              },
          })
        : null;

export function isSupabaseConfigured() {
    return Boolean(supabase);
}

/** Avoid leaking project URLs, keys, or raw PostgREST payloads in the UI or console. */
export function sanitizeSupabaseError(error, fallback = "Could not complete request.") {
    if (!error) return fallback;

    const raw =
        typeof error === "string"
            ? error
            : error.message || error.error_description || fallback;

    if (!isProd) return raw;

    const sensitive =
        /supabase\.co|eyJ[a-zA-Z0-9_-]*\.eyJ|apikey|service_role|postgres|JWT|Bearer\s/i.test(
            raw,
        );

    if (sensitive) return fallback;

    return raw.length > 100 ? fallback : raw;
}
